import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
  Modal,
  Button,
  Text,
  Checkbox,
  Stack
} from '@efast_public/fjd-component-library';
import { LocalStorageKeys } from '../utils/odUtil';

interface VVExpertModeRedirectModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  shouldBackTextBeVisible?: boolean;
}

export function VVExpertModeRedirectModal({
  onClose,
  onConfirm,
  isOpen,
  shouldBackTextBeVisible = true
}: VVExpertModeRedirectModalProps) {
  const { t } = useTranslation();
  const [shouldRedirect, setShouldRedirect] = useState(
    localStorage.getItem(
      LocalStorageKeys.shouldRedirectInstantlyToExpertMode
    ) === 'true'
  );

  const handleConfirm = () => {
    if (shouldRedirect) {
      localStorage.setItem(
        LocalStorageKeys.shouldRedirectInstantlyToExpertMode,
        'true'
      );
    }
    onConfirm();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Header id="modal-header">
        <Text size="xl" strong>
          {t('VVExpertModeRedirectModal.title')}
        </Text>
      </Modal.Header>
      <Modal.Content>
        <Stack spacing="l" orientation="vertical">
          <Text size="m">
            {t('VVExpertModeRedirectModal.description.line1')}
          </Text>
          {shouldBackTextBeVisible && (
            <Text size="m">
              {t('VVExpertModeRedirectModal.description.line2')}
            </Text>
          )}
          <Checkbox
            checked={shouldRedirect}
            onChange={(e) => setShouldRedirect(e.currentTarget.checked)}
            label={t('VVExpertModeRedirectModal.dontShowAgain')}
          />
        </Stack>
      </Modal.Content>
      <Modal.Footer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            width: '100%'
          }}
        >
          <Button
            variant="secondary-outline"
            onClick={onClose}
            style={{ flex: 1 }}
          >
            {t('VVExpertModeRedirectModal.actions.cancel')}
          </Button>
          <Button variant="primary" onClick={handleConfirm} style={{ flex: 1 }}>
            {t('VVExpertModeRedirectModal.actions.confirm')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
